import fpsPayeeMock from "./fpsPayee";
import sepaPayeeMock from "./sepaPayee";
import swiftPayeeEurMock from "./swiftPayeeEur";
import swiftPayeeGbpMock from "./swiftPayeeGbp";

const gbpMockPayees = [fpsPayeeMock, fpsPayeeMock, swiftPayeeGbpMock];
const eurMockPayees = [
  sepaPayeeMock,
  sepaPayeeMock,
  swiftPayeeEurMock,
  sepaPayeeMock,
  sepaPayeeMock,
  swiftPayeeEurMock,
  sepaPayeeMock,
  sepaPayeeMock,
  swiftPayeeEurMock,
  sepaPayeeMock,
  sepaPayeeMock,
  swiftPayeeEurMock,
  sepaPayeeMock,
  sepaPayeeMock,
  swiftPayeeEurMock,
];

export {gbpMockPayees, eurMockPayees};